import React, { useEffect, useState } from 'react';
import { Button, Modal, Radio, Tabs } from 'antd';
import { CloudDownloadOutlined } from '@ant-design/icons';

import { useDispatch, useSelector } from 'react-redux';
import {
  fetchYears,
  fetchquestionnaireNames,
  fetchgetQuestionsById,
  emptyQuestionbyId
} from '../category.action';

import './styles.scss';
import Loader from 'components/ui/Loader';
import { excelDownloader, flattenData, wordDownload } from 'utils/functions';

export default function DownloadModal({ isModalOpen, handleOk, handleCancel }) {
  const dispatch = useDispatch();
  const [activeKey, setActiveKey] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [curentqTitle, setCurentqTitle] = useState('');
  const [loader, setLoader] = useState(false);
  const categoriesState = useSelector((state) => state.category);

  const {
    questionLoader = false,
    questionnaireNames = [],
    years = [],
    questionData = [],
    isFetch = false
  } = categoriesState;

  useEffect(() => {
    dispatch(fetchYears());
    // eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    if (years.length > 0) {
      const firstyear = years[0];
      setActiveKey(firstyear);
      dispatch(fetchquestionnaireNames(firstyear));
    }

    // eslint-disable-next-line
  }, [years]);

  const handleYearClick = (year) => {
    setActiveKey(year);
    setCurrentQuestion(null);
    dispatch(fetchquestionnaireNames(year));
    dispatch(emptyQuestionbyId());
  };
  const handleQnameChange = (e) => {
    setCurrentQuestion(e.target.value);
    const qtitle = questionnaireNames.filter((item) => item.id == e.target.value)[0];
    setCurentqTitle(qtitle?.name);
    dispatch(emptyQuestionbyId());
  };
  const handleGetQuestion = () => {
    dispatch(fetchgetQuestionsById(currentQuestion));
  };

  const handleDownload = () => {
    const data = flattenData(questionData);
    const filename = curentqTitle.replace(' ', '_');
    excelDownloader(data, filename, setLoader);
  };

  // word download

  const handleDownloadWord = async () => {
    const filename = curentqTitle.replace(' ', '_');
    wordDownload(questionData, filename, setLoader);
  };

  return (
    <div>
      {loader && <Loader />}
      <Modal
        title={
          <>
            Questionnaire{' '}
            <div className="subtittlemodal">Please choose a year to download questionnaire</div>
          </>
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        centered
        width={750}
        footer={
          <div className="modalfooter">
            <div className="modalbtn-area">
              Select option to download your survey.
              {isFetch && questionData.length < 1 && (
                <>
                  <div style={{ color: 'red' }}>No Data avaliable!</div>
                </>
              )}
              <div className="btnarea">
                {isFetch && questionData.length > 0 ? (
                  <>
                    <Button type="primary" onClick={handleDownload}>
                      <CloudDownloadOutlined />
                      Excel
                    </Button>
                    <Button type="primary" onClick={handleDownloadWord}>
                      <CloudDownloadOutlined /> Word
                    </Button>
                  </>
                ) : (
                  <Button
                    type="primary"
                    disabled={!currentQuestion && questionData.length < 1}
                    onClick={handleGetQuestion}
                  >
                    Get Question
                  </Button>
                )}
              </div>
            </div>
          </div>
        }
      >
        <div className="mdlcontent">
          {questionLoader && <Loader />}
          <Tabs
            tabPosition="left"
            activeKey={activeKey}
            tabBarExtraContent={{ left: <span className="mdl-title">Year</span> }}
            onChange={handleYearClick}
            items={years.map((item) => ({
              label: `${item}`,
              key: item,
              children: (
                <div className="questionname">
                  <Radio.Group onChange={handleQnameChange} value={currentQuestion}>
                    {questionnaireNames?.map((item) => (
                      <div className="qname" key={item.id}>
                        <Radio key={item.id} value={item.id}>
                          {item.name}
                        </Radio>
                      </div>
                    ))}
                  </Radio.Group>
                </div>
              )
            }))}
          />
          <div className="mdl-title qlist">Questionnaire List</div>
          {/* Show a message when no tab is selected */}
          {!activeKey && <div className="tabmsg">Please select a year to load data.</div>}
        </div>
      </Modal>
    </div>
  );
}
